import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Nav from './nav';
import Header from './header';

const APP_BAR_MOBILE = 64;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 40,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout({ handleThemeChange, isDarkMode, textSize, setTextSize }) {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />
      <Nav
        openNav={open}
        onCloseNav={() => setOpen(false)}
        handleThemeChange={handleThemeChange}
        isDarkMode={isDarkMode}
        textSize={textSize}
        setTextSize={setTextSize}
      />
      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
